if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

document.addEventListener("click", function (e) {
  const target = e.target.closest('a[href*="#"]');
  if (target) {
    const href = target.getAttribute("href");

    const currentPath = window.location.pathname;
    const targetPath = target.pathname;

    if (
      href.includes("#") &&
      !href.includes("recover") &&
      (targetPath === currentPath || href.startsWith("#"))
    ) {
      e.preventDefault();

      const hashIndex = href.indexOf("#");
      const targetId = href.substring(hashIndex + 1);
      smoothScrollToTarget(targetId);

      const details = document.getElementById("Details-menu-drawer-container");
      if (details && details.hasAttribute("open")) {
        details.removeAttribute("open");
      }
    }
  }
});

window.addEventListener("load", () => {
  const hash = window.location.hash;
  if (hash && hash.length > 1) {
    const targetId = hash.substring(1);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        smoothScrollToTarget(targetId);
      });
    });
  }
});

function smoothScrollToTarget(targetId) {
  let finalTargetId = targetId;
  let targetElement = null;
  const headerHeight =
    document.querySelector(".header-wrapper")?.offsetHeight || 0;

  if (targetId === "visit-us") {
    const viewportWidth = window.innerWidth;

    if (viewportWidth <= 768) {
      finalTargetId = "visit-us-wrapper-mobile";
      targetElement = document.getElementById(finalTargetId);
    } else if (viewportWidth <= 1024) {
      targetElement = document.querySelector(".visit-us-wrapper");
    } else {
      finalTargetId = "visit-us";
      targetElement = document.getElementById(finalTargetId);
    }
  } else {
    targetElement = document.getElementById(finalTargetId);
  }

  if (targetElement) {
    let extraOffset = 0;
    if (finalTargetId === "visit-us-wrapper-mobile") {
      extraOffset = 112;
    }

    window.scrollTo({
      top: targetElement.offsetTop - headerHeight - extraOffset,
      behavior: "smooth",
    });
  }
}
